/* eslint-disable import/prefer-default-export */

import { Model, fetchWp } from './core';

export function fetchPrograms(query) {
  return fetchWp({ path: 'products', query });
}

export async function fetchProgram(slug) {
  return (await fetchPrograms({ slug }))[0];
}

export function fetchCategories(query) {
  return fetchWp({ path: 'product-categories', query });
}

export async function fetchCategory(slug) {
  return (await fetchCategories({ slug }))[0];
}

export default class Program extends Model {
  static get endpoint() {
    return 'wp/v2/products';
  }
}
